export default "__VITE_ASSET__B7VnNS0I__"